import type { CSSProperties } from 'react';
import { msg } from '@gonfalon/messages/msg';
import clsx from 'clsx';

import styles from './Skeleton.module.css';

export interface SkeletonProps {
  width?: number | string;
  height?: number | string;
  className?: string;
  style?: CSSProperties;
}

/**
 * Generic customizable loading area component that displays an animated placeholder in any given width and height.
 * Can be used as a base building block for more complex loading states and layouts.
 */
export function Skeleton({ width = '100%', height = '2rem', className, style }: SkeletonProps) {
  const inlineStyles = {
    '--skeleton-width': typeof width === 'number' ? `${width}px` : width,
    '--skeleton-height': typeof height === 'number' ? `${height}px` : height,
    ...style,
  } as CSSProperties;

  return (
    <div
      className={clsx(styles.skeleton, className)}
      style={inlineStyles}
      role="status"
      aria-label={msg('ui.skeleton.loadingLabel')}
      aria-busy="true"
    />
  );
}
